/**
 * §15: reject control characters and invisible bidi/formatting characters in user input
 * (names, company names). Tabs/newlines are control characters too.
 */
const FORBIDDEN_CHARS = /[\p{Cc}\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF]/u;

export function containsControlCharacters(value: string): boolean {
  return FORBIDDEN_CHARS.test(value);
}
